import React, { useEffect, useState } from 'react';
import OriginField from './OriginField';


const AddOrigin = () => {
     return (
        <div className='mx-auto w-full p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A New Origin</h1>
            <OriginField></OriginField>
        </div>
    );
};

export default AddOrigin;